// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"911950b8","364":"fd040a05","616":"400da217","625":"fb29a212"}[chunkId] + ".chunk.js";
};